module.exports = __webpack_public_path__ + "img/Epiito_App_Icons_CAVE.53425f86.png";